var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useRef, useState } from 'react';
import { deepClone } from '../util/clone';
import { useOnOutClick } from './useOnOutClick';
export function useModalPosition(options) {
    var clickTargetRef = (options === null || options === void 0 ? void 0 : options.ref) ? options === null || options === void 0 ? void 0 : options.ref : useRef(null);
    var scrollContainerChildRef = useRef();
    var isScrolling = useRef(false);
    var observerEntriesSeen = useRef(new Set());
    var _a = __read(useState(null), 2), positionData = _a[0], setPositionData = _a[1];
    var _b = __read(useOnOutClick(clearPositionData), 1), modalRef = _b[0];
    function clearPositionData() {
        setPositionData(null);
    }
    function updatePosition(rectangle) {
        var _a, _b;
        var _c = (_b = (_a = options === null || options === void 0 ? void 0 : options.addOffset) === null || _a === void 0 ? void 0 : _a.call(options, rectangle)) !== null && _b !== void 0 ? _b : {}, _d = _c.offsetTop, offsetTop = _d === void 0 ? 0 : _d, _e = _c.offsetLeft, offsetLeft = _e === void 0 ? 0 : _e;
        var copy = deepClone(rectangle);
        copy = __assign(__assign({}, copy), { left: rectangle.left + offsetLeft, top: rectangle.top + offsetTop });
        setPositionData(copy);
    }
    useEffect(function () {
        if (!clickTargetRef.current) {
            return;
        }
        function updatePositionHandler(e) {
            var target = e.currentTarget;
            if (!!positionData) {
                clearPositionData();
                return;
            }
            var rectangle = target.getBoundingClientRect();
            updatePosition(rectangle);
        }
        function scrollHandler(e) {
            var _a, _b, _c, _d, _e, _f;
            isScrolling.current = true;
            var target = e.target;
            if (!positionData || !clickTargetRef.current || !target.contains(clickTargetRef.current)) {
                return;
            }
            var holderRectangle = target.getBoundingClientRect();
            var rectangle = clickTargetRef.current.getBoundingClientRect();
            var _g = (_b = (_a = options === null || options === void 0 ? void 0 : options.addOffset) === null || _a === void 0 ? void 0 : _a.call(options, rectangle)) !== null && _b !== void 0 ? _b : {}, _h = _g.offsetTop, offsetTop = _h === void 0 ? 0 : _h, _j = _g.offsetLeft, offsetLeft = _j === void 0 ? 0 : _j, _k = _g.visibleOffsetLeft, visibleOffsetLeft = _k === void 0 ? 0 : _k, _l = _g.visibleOffsetTop, visibleOffsetTop = _l === void 0 ? 0 : _l;
            var isVisibleVertical = rectangle.top <= holderRectangle.top
                ? (_c = holderRectangle.top - rectangle.top <= rectangle.height + visibleOffsetTop) !== null && _c !== void 0 ? _c : offsetTop
                : (_d = rectangle.bottom - holderRectangle.bottom <= rectangle.height + visibleOffsetTop) !== null && _d !== void 0 ? _d : offsetTop;
            var isVisibleHorizontal = rectangle.left <= holderRectangle.left
                ? (_e = holderRectangle.left - rectangle.left <= rectangle.width + visibleOffsetLeft) !== null && _e !== void 0 ? _e : offsetLeft
                : (_f = rectangle.right - holderRectangle.right <= rectangle.width + visibleOffsetLeft) !== null && _f !== void 0 ? _f : offsetLeft;
            var copy = deepClone(rectangle);
            copy = __assign(__assign({}, copy), { left: rectangle.left + offsetLeft, top: rectangle.top + offsetTop });
            setPositionData(isVisibleHorizontal && isVisibleVertical ? copy : null);
            isScrolling.current = false;
        }
        clickTargetRef.current.addEventListener('click', updatePositionHandler);
        window.addEventListener('scroll', scrollHandler, true);
        return function () {
            var _a;
            (_a = clickTargetRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('click', updatePositionHandler);
            window.removeEventListener('scroll', scrollHandler, true);
        };
    }, [
        positionData,
        scrollContainerChildRef.current,
        isScrolling.current,
        observerEntriesSeen.current,
        clickTargetRef,
        options === null || options === void 0 ? void 0 : options.addOffset,
    ]);
    return [clickTargetRef, modalRef, positionData, clearPositionData];
}
